import { message as staticMessage } from 'antd'
import type { MessageInstance } from 'antd/es/message/interface'

/**
 * 非 React 上下文取用 antd message 的桥接。
 *
 * antd 6 起，`message.xxx()` 静态方法无法消费 ConfigProvider 的 context
 * （主题、locale），控制台会告警，官方方案是改用 `App.useApp()` 拿 context 实例。
 * 但请求拦截器这类模块不是组件，用不了 hook —— 由 {@link AntdStaticBridge}
 * 在 App 挂载后把实例注入进来，这里再转交给它们。
 *
 * App 挂载前（例如应用启动阶段就失败的请求）回退到静态方法：宁可带一次告警，
 * 也不能把错误提示整个吞掉。
 */
let messageInstance: MessageInstance | null = null

export function setMessageInstance(instance: MessageInstance): void {
  messageInstance = instance
}

/** 取当前可用的 message 实例；App 未挂载时回退静态方法。 */
export function getMessage(): MessageInstance {
  return messageInstance ?? staticMessage
}
